import types from 'actions/types'
import {combineReducers} from 'redux'

export const isLoadingClientSecret = (state = false, action) => {
  switch (action.type) {
    case types.SUBSCRIPTIONS_GET_CLIENT_SECRET_ATTEMPT: return true
    case types.SUBSCRIPTIONS_GET_CLIENT_SECRET_FAILURE: return false
    case types.SUBSCRIPTIONS_GET_CLIENT_SECRET_SUCCESS: return false
    default: return state
  }
}

export const clientSecret = (state = null, action) => {
  switch (action.type) {
    case types.SUBSCRIPTIONS_GET_CLIENT_SECRET_ATTEMPT:
      return null
    case types.SUBSCRIPTIONS_GET_CLIENT_SECRET_SUCCESS:
      return action.clientSecret
    case types.SUBSCRIPTIONS_GET_CLIENT_SECRET_FAILURE:
      return null
    default:
      return state
  }
}

export const clientSecretError = (state = null, action) => {
  switch (action.type) {
    case types.SUBSCRIPTIONS_GET_CLIENT_SECRET_ATTEMPT:
      return null
    case types.SUBSCRIPTIONS_GET_CLIENT_SECRET_FAILURE:
      return action.message
    default:
      return state
  }
}

export const planPrices = (state = {}, action) => {
  switch (action.type) {
    case types.SUBSCRIPTIONS_GET_PRICE_ATTEMPT:
      return {}
    case types.SUBSCRIPTIONS_GET_PRICE_SUCCESS:
      return action.planPrices
    default:
      return state
  }
}

export const loadingPlanPrices = (state = false, action) => {
  switch (action.type) {
    case types.SUBSCRIPTIONS_GET_PRICE_ATTEMPT:
      return true
    case types.SUBSCRIPTIONS_GET_PRICE_SUCCESS:
      return false
    case types.SUBSCRIPTIONS_GET_PRICE_FAILURE:
      return false
    default:
      return state
  }
}

export const upcomingInvoice = (state = null, action) => {
  switch (action.type) {
    case types.SUBSCRIPTIONS_LOAD_UPCOMING_INVOICE_ATTEMPT:
      return null
    case types.SUBSCRIPTIONS_LOAD_UPCOMING_INVOICE_SUCCESS:
      return action.data
    case types.SUBSCRIPTIONS_LOAD_UPCOMING_INVOICE_FAILURE:
      return null
    default:
      return state
  }
}

export const cancellationDate = (state = null, action) => {
  switch (action.type) {
    case types.SUBSCRIPTIONS_GET_CANCEL_DATE_ATTEMPT:
      return null
    case types.SUBSCRIPTIONS_GET_CANCEL_DATE_SUCCESS:
      return action.cancelDate
    case types.SUBSCRIPTIONS_GET_CANCEL_DATE_FAILURE:
      return null
    default:
      return state
  }
}

export default combineReducers({
  isLoadingClientSecret,
  clientSecret,
  clientSecretError,
  planPrices,
  loadingPlanPrices,
  upcomingInvoice,
  cancellationDate,
})